import type { ReactNode } from "react";
import { CircleCheck } from "lucide-react";

import styles from "./integrations.module.css";

/**
 * Nothing waiting — said calmly, with the list of what is being watched and a
 * check beside each, so "empty" reads as "checked" rather than "broken".
 */
export function AllClear({
  title,
  note,
  watching,
}: {
  title: string;
  note?: ReactNode;
  watching: { title: string; note: string }[];
}) {
  return (
    <section className={styles.clear} aria-label={title}>
      <div className={styles.clearHead}>
        <span className={styles.clearIcon}>
          <CircleCheck size={24} aria-hidden />
        </span>
        <div className={styles.panelHeadText}>
          <h2 className={styles.clearTitle}>{title}</h2>
          {note && <p className={styles.clearNote}>{note}</p>}
        </div>
      </div>
      <ul className={styles.watch} aria-label="What is being watched">
        {watching.map((one) => (
          <li key={one.title} className={styles.watchItem}>
            <CircleCheck size={16} aria-label="nothing waiting" />
            <span>
              <span className={styles.watchTitle}>{one.title}</span>
              <br />
              {one.note}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
